import { UserCurrent, UserRole } from '@/http/api/users'

import { Permission, companyRoles } from './roles'

// Memoized permission map for faster lookups
const rolePermissionMap = new Map<UserRole, Set<Permission>>(
  companyRoles.map((role) => [role.id, new Set(role.permissions)]),
)

export type HasPermissionsOptions = {
  to: Permission | Permission[]
}

/**
 * Checks if the user has access to the given resource(s)
 *
 * @param user - The user to check access for.
 * @param options - Object containing the resource(s) to check access for.
 * @param options.to - The resource(s) to check access for. Can be a single resource or an array of resources.
 * @returns {boolean} True if the user has access to at least one resource, false otherwise.
 */
export function hasPermissions(
  user: UserCurrent | undefined,
  options: HasPermissionsOptions,
) {
  if (!user) {
    return false
  }

  const resourcesToCheck = Array.isArray(options.to) ? options.to : [options.to]

  return resourcesToCheck.some((resource) =>
    user.roles.some(
      (role) => rolePermissionMap.get(role)?.has(resource) ?? false,
    ),
  )
}
